import { Eye, User } from 'lucide-react';
import { Link, generatePath } from 'react-router-dom';

import routesPath from '@/shared/constants/routesPath';
import useBowlingCentersStore from '@/shared/store/bowlingCenters';
import { cn } from '@/shared/utils';
import { formatBowlingCenterAddress } from '@/shared/utils/bowlingCenters';

const BcCard = ({ data }) => {
  const { addRecentCenter, addCurrentCenter } = useBowlingCentersStore();

  return (
    <Link
      to={generatePath(routesPath.LIVESCORING, { uuid: data.uuid })}
      onClick={() => {
        addRecentCenter(data);
        addCurrentCenter(data);
      }}
    >
      <div
        className={cn(
          'flex flex-col py-2.5 transition-all bg-gradient-to-l from-primary/0',
          'hover:bg-gradient-to-tl hover:from-primary/10 hover:pr-6'
        )}
      >
        <div className="flex md:gap-4 items-center max-md:flex-wrap">
          <div className="flex-1 min-w-0">
            <div className="text-base font-bold max-md:max-w-full flex items-center gap-2">
              {data.companyName}
              {data.features?.premium && (
                <img
                  src="/images/star.png"
                  alt="premium"
                  className="size-4 inline-block flex-shrink-0"
                />
              )}
            </div>
            <div className="text-xs font-semibold tracking-wider uppercase text-neutral-400">
              {data.lanes} lanes
            </div>
            <div className="flex items-center gap-2 py-2">
              <img
                loading="lazy"
                src={data.countryFlag}
                alt="flag of the country"
                className="w-4 aspect-video"
              />
              <p className="text-sm text-neutral-400 leading-4 lg:truncate max-w-[600px]">
                {formatBowlingCenterAddress(data)}
              </p>
            </div>
          </div>

          <div
            className="flex items-center gap-1 text-sm font-medium"
            data-cy="viewers"
          >
            <Eye size={16} />
            {data.viewersCurrent}
          </div>
          <div
            className="flex items-center gap-1 text-sm font-medium"
            data-cy="games"
          >
            <User size={16} />
            {data.activeGames}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BcCard;
